import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { Avatar, Box, Button, styled, Typography } from "@mui/material";
import avr1 from "../images/avr1.png";
import avr2 from "../images/avr2.png";
import avr3 from "../images/avr3.png";
import avr4 from "../images/avr4.png";
import avr5 from "../images/avr5.png";
import avr6 from "../images/avr6.png";
import avr7 from "../images/avr7.png";
import avr8 from "../images/avr8.png";
import avr9 from "../images/avr9.png";
import avr10 from "../images/avr10.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import cr1 from "../images/cr1.png";
import cr2 from "../images/cr2.png";
import cr3 from "../images/cr3.png";
import cr4 from "../images/cr4.png";
import cr5 from "../images/cr5.png";
import cr6 from "../images/cr6.png";
import cr7 from "../images/cr7.png";
import cr8 from "../images/cr8.png";
import cr9 from "../images/cr9.png";
import cr10 from "../images/cr10.png";
import { Link } from "react-router-dom";
import FloatingSocialIcons from "../Pages/SocialMedia";
import Colors from "../components_new/Colors";
import HomeHeader from "../components_new/HomeHeader";
import SliderComponent from "../components_new/Slider";
import TypographyComponentNormal from "../components_new/TypographyComponentNormal";
import Welcome from "./Welcome";
import { Remove } from "@mui/icons-material";
import TinyThinkers from "../images_new/TinyThinkers.svg";
import masterminds from "../images_new/masterminds.svg";
import logiclegends from "../images_new/logiclegends.svg";
import TinyThinkersMob from "../images_new/TinyThinkersMob.svg";
import mastermindsMob from "../images_new/mastermindsMob.svg";
import logiclegendsMob from "../images_new/logiclegendsMob.svg";
import TypographyComponent from "../components_new/TypographyComponent";
import ButtonComponent from "../components_new/ButtonComponent";
import PlayButtonComponent from "../components_new/PlayButtonComponent";
import GameLevel from "../components_new/GameLevel";

function Home() {
  const [creators, setCreators] = useState([]);
  const [creatorDetails, setCreatorDetails] = useState([]);
  const [uniqueGameIds, setUniqueGameIds] = useState([]);
  const [isCreator, setIsCreator] = useState(false);
  const [creatorId, setCreatorId] = useState(null);
  const [playedGames, setPlayedGames] = useState([]);
  const [showWelcome, setShowWelcome] = useState(true);
  const [playerScore, setPlayerScore] = useState(null);

  const avatarMap = {
    1: avr1,
    2: avr2,
    3: avr3,
    4: avr4,
    5: avr5,
    6: avr6,
    7: avr7,
    8: avr8,
    9: avr9,
    0: avr10,
  };
  const creatorMap = {
    1: cr1,
    2: cr2,
    3: cr3,
    4: cr4,
    5: cr5,
    6: cr6,
    7: cr7,
    8: cr8,
    9: cr9,
    0: cr10,
  };

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.get(`${API_URL}/classify_games`);
        setCreators(response.data);
        localStorage.setItem("Data", response.data);
        // console.log('classify_games',response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameData();
  }, []);

  const launchingThusharam = creators.filter(
    (creator) => creator.category === "തുഷാരം",
  );
  const launchedHemandam = creators.filter(
    (creator) => creator.category === "ഹേമന്തം",
  );
  const launchedNeeharam = creators.filter(
    (creator) => creator.category === "നീഹാരം",
  );

  const uniquelaunchingThusharam = Array.from(
    new Map(
      launchingThusharam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedHemandam = Array.from(
    new Map(
      launchedHemandam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniquelaunchedNeeharam = Array.from(
    new Map(
      launchedNeeharam.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );

  // Split creators into groups of 5 for display
  const uniqueThusharam = [];
  const uniqueHemandam = [];
  const uniqueNeeharam = [];

  let chunkSizelaunchingThusharam = 5; // Default chunk size for desktop
  let chunkSizelaunchedHemandam = 5;
  let chunkSizelaunchedNeeharam = 5;

  // Check if the screen width is small (mobile)
  if (window.innerWidth <= 568) {
    // Adjust this value based on your breakpoint
    chunkSizelaunchingThusharam = 2; // Chunk size for mobile
    chunkSizelaunchedHemandam = 2; // Chunk size for mobile
    chunkSizelaunchedNeeharam = 2;
  }

  for (
    let i = 0;
    i < uniquelaunchingThusharam.length;
    i += chunkSizelaunchingThusharam
  ) {
    uniqueThusharam.push(
      uniquelaunchingThusharam.slice(i, i + chunkSizelaunchingThusharam),
    );
  }

  for (
    let i = 0;
    i < uniquelaunchedHemandam.length;
    i += chunkSizelaunchedHemandam
  ) {
    uniqueHemandam.push(
      uniquelaunchedHemandam.slice(i, i + chunkSizelaunchedHemandam),
    );
  }

  for (
    let i = 0;
    i < uniquelaunchedNeeharam.length;
    i += chunkSizelaunchedNeeharam
  ) {
    uniqueNeeharam.push(
      uniquelaunchedNeeharam.slice(i, i + chunkSizelaunchedNeeharam),
    );
  }

  // Fetch details for a specific creator
  const handleCreatorClick = async (creatorId, status) => {
    setIsCreator(true);
    setCreatorId(creatorId);
    localStorage.setItem("selectedCreator", creatorId);
    localStorage.setItem("selectedCat", status);
    if (!localStorage.getItem("PlayerTocken")) {
      window.location.href = "/player-signin";
    } else {
      window.location.href = "/all-game";
    }
  };

  const handleGameClick = async (gameId) => {
    localStorage.setItem("gameId", gameId);
    localStorage.setItem("creatorId", creatorId);
    window.location.href = "/play-game";
  };

  function formatPublishingTime(dateString) {
    // Check if dateString is valid
    if (!dateString) {
      console.error("Invalid date string:", dateString);
      return ""; // Return an empty string or handle this case as needed
    }

    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date)) {
      console.error("Invalid date object:", date);
      return ""; // Return an empty string or handle this case as needed
    }

    const dateOnly = date.toISOString().split("T")[0];
    const today = new Date();

    // Check if the date is today
    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return "TODAY";
    }

    // Format the date to 'DD MMM YYYY' (e.g., 31 JAN 2025)
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date).toUpperCase();
  }

  const isToday = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(false);
    }, 2000); // 2000ms = 2 seconds

    return () => clearTimeout(timer); // Cleanup function
  }, []);

  useEffect(() => {
    const fetchGameScoreData = async () => {
      try {
        const response = await axios.post(`${API_URL}/player_score`, {
          PlayerTocken: localStorage.getItem("PlayerTocken"),
        });
        setPlayerScore(response.data.totalScore);
        console.log("creator id", localStorage.getItem("SelectedId"));
        console.log("player score", response.data.result);
        const clickId = localStorage.getItem("SelectedId");
        const gameData = response.data.result;
        //  const filteredGames = gameData.filter((game) => game.creator_id === clickId);
        const filteredGames = gameData.rows.filter(
          (game) => game.creator_id === Number(clickId),
        );
        setPlayedGames(filteredGames);
        console.log("filteredGames", filteredGames);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameScoreData();
    const intervalId = setInterval(fetchGameScoreData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "28px",
        background: Colors.bgColor,
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100%",
      }}
    >
      <HomeHeader />

      {showWelcome && (
        <Box sx={{ width: "100%", marginTop: "-28px" }}>
          <Welcome></Welcome>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          maxWidth: { xs: "90%", md: "90.5%" },
          gap: "32px",
          height: "100%",
          marginBottom: "5%",
        }}
      >
        {!localStorage.getItem("PlayerTocken") && (
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              marginBottom: "-24px",
              width: "100%",
              height: { md: "30px", xs: "16px" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TypographyComponentNormal
              sx={{
                textAlign: "center",
                fontSize: { md: "20px", xs: "11px" },
              }}
            >
              You can only earn points if you have an account.{" "}
              <Link
                to="/player-signup"
                style={{
                  color: Colors.linkColor,
                  textDecoration: "none",
                  fontSize: { md: "20px", xs: "11px" },
                }}
              >
                Create an account
              </Link>
            </TypographyComponentNormal>
          </Box>
        )}

        {localStorage.getItem("PlayerTocken") && (
          <GameLevel points={playerScore}></GameLevel>
        )}

        <Box
          sx={{
            width: "100%",
            height: "178px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SliderComponent></SliderComponent>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <TypographyComponentNormal
              sx={{ fontWeight: 600, fontSize: "28px", color: Colors.greyFont }}
            >
              Daily puzzle
            </TypographyComponentNormal>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { md: "32px", xs: "24px" },
              width: "100%",
              height: "100%",
            }}
          >
            {uniqueThusharam.length > 0 && (
              <Box sx={{ display: "flex", width: "100%" }}>
                {uniqueThusharam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", gap: "16px", width: "100%" }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: { md: "center", xs: "flex-start" },
                          borderRadius: "16px",
                          boxShadow: "0px 5px 6px 0px #00000040",
                          width: "100%",
                          height: { md: "378px", xs: "140px" },
                          backgroundImage: {
                            md: `url(${TinyThinkers})`,
                            xs: `url(${TinyThinkersMob})`,
                          },
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: { md: "calc(100% - 64px)", xs: "58%" },
                            padding: { md: "32px 32px 12px 32px", xs: "20px" },
                            height: "100%",
                            gap: "12px",
                          }}
                        >
                          <TypographyComponent
                            sx={{
                              color: Colors.tinyFont,
                              fontSize: { md: "28px", xs: "24px" },
                            }}
                          >
                            Tiny thinkers
                          </TypographyComponent>
                          <TypographyComponentNormal
                            sx={{
                              fontWeight: 600,
                              fontSize: { md: "16px", xs: "12px" },
                              lineHeight: { md: "20px", xs: "14px" },
                              color: Colors.white,
                            }}
                          >
                            Made just for little ones (below 8)Safe, fun, and
                            easy to explore
                          </TypographyComponentNormal>
                          <PlayButtonComponent
                            sx={{
                              background: Colors.tinyButton,
                              fontSize: { md: "16px", xs: "12px" },
                              marginTop: { md: "auto", xs: "0px" },
                              width: { md: "100%", xs: "90px" },
                            }}
                          ></PlayButtonComponent>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}

            {uniqueHemandam.length > 0 && (
              <Box sx={{ display: "flex", width: "100%" }}>
                {uniqueHemandam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", gap: "16px", width: "100%" }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: { md: "center", xs: "flex-start" },
                          borderRadius: "16px",
                          boxShadow: "0px 5px 6px 0px #00000040",
                          width: "100%",
                          height: { md: "378px", xs: "140px" },
                          backgroundImage: {
                            md: `url(${masterminds})`,
                            xs: `url(${mastermindsMob})`,
                          },
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: { md: "calc(100% - 64px)", xs: "58%" },
                            padding: { md: "32px 32px 12px 32px", xs: "20px" },
                            height: "100%",
                            gap: "12px",
                          }}
                        >
                          <TypographyComponent
                            sx={{
                              color: Colors.masterFont,
                              fontSize: { md: "28px", xs: "24px" },
                            }}
                          >
                            Master mind
                          </TypographyComponent>
                          <TypographyComponentNormal
                            sx={{
                              fontWeight: 600,
                              fontSize: { md: "16px", xs: "12px" },
                              lineHeight: { md: "20px", xs: "14px" },
                              color: Colors.white,
                            }}
                          >
                            Designed for growing minds (8 to 20)! Engaging,
                            exciting, and just right for you.
                          </TypographyComponentNormal>
                          <PlayButtonComponent
                            sx={{
                              background: Colors.masterButton,
                              fontSize: { md: "16px", xs: "12px" },
                              marginTop: { md: "auto", xs: "0px" },
                              width: { md: "100%", xs: "90px" },
                            }}
                          ></PlayButtonComponent>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}

            {uniqueNeeharam.length > 0 && (
              <Box sx={{ display: "flex", width: "100%" }}>
                {uniqueNeeharam.map((chunk, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", gap: "16px", width: "100%" }}
                  >
                    {chunk.map((creator) => (
                      <Box
                        key={creator.creator_id}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: { md: "center", xs: "flex-start" },
                          borderRadius: "16px",
                          boxShadow: "0px 5px 6px 0px #00000040",
                          width: "100%",
                          height: { md: "378px", xs: "140px" },
                          backgroundImage: {
                            md: `url(${logiclegends})`,
                            xs: `url(${logiclegendsMob})`,
                          },
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: { md: "calc(100% - 64px)", xs: "58%" },
                            padding: { md: "32px 32px 12px 32px", xs: "20px" },
                            height: "100%",
                            gap: "12px",
                          }}
                        >
                          <TypographyComponent
                            sx={{
                              color: Colors.logicFont,
                              fontSize: { md: "28px", xs: "24px" },
                            }}
                          >
                            Logic legends
                          </TypographyComponent>
                          <TypographyComponentNormal
                            sx={{
                              fontWeight: 600,
                              fontSize: { md: "16px", xs: "12px" },
                              lineHeight: { md: "20px", xs: "14px" },
                              color: Colors.white,
                            }}
                          >
                            For Adults 20+ , Learn, grow, and explore with ease.
                          </TypographyComponentNormal>
                          <PlayButtonComponent
                            sx={{
                              background: Colors.logicFont,
                              fontSize: { md: "16px", xs: "12px" },
                              marginTop: { md: "auto", xs: "0px" },
                              width: { md: "100%", xs: "90px" },
                            }}
                          ></PlayButtonComponent>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            width: { md: "calc(100% - 40px)", xs: "calc(100% - 16px)" },
            height: { md: "36px", xs: "91px" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: Colors.getInTouchBg,
            padding: { md: "20px", xs: "8px" },
            borderRadius: "12px",
            flexDirection: "row",
            boxShadow: " 0px 2px 6px 0px #00000040",
          }}
        >
          <TypographyComponentNormal
            sx={{
              color: Colors.getInTouchFont,
              fontSize: { md: "16px", xs: "10px" },
              fontWeight: 400,
              lineHeight: { md: "20px", xs: "14px" },
            }}
          >
            We value your feedback! Please share your thoughts and experiences
            to help us improve the game. If you have any queries, feel free to
            contact us.
          </TypographyComponentNormal>
          <ButtonComponent
            sx={{
              background: Colors.getInTouchButton,
              width: { md: "136px", xs: "fit-content" },
              minWidth: "auto",
              whiteSpace: "nowrap",
              "&:hover": { background: Colors.getInTouchButtonHover },
            }}
          >
            Get in touch
          </ButtonComponent>
        </Box>
      </Box>
    </Box>
  );
}

export default Home;
